import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import {
  formatISO,
  parseISO,
  differenceInHours,
  formatDistanceToNow,
  format,
} from 'date-fns';
import { withNamespaces } from 'react-i18next';
import { formatDate } from 'utils';
import { DataFormatter } from 'constants/global';
import Tooltip from 'components/Tooltip';

@withNamespaces()
@observer
// TODO: this collides with global Date, we should rename this
// to DateComponent here and in the rest of the code where we
// use this
class Date extends React.Component {
  render() {
    const {
      className,
      value,
      noRelative,
      dataTestId,
      formatter,
      hideTooltip,
      tooltipProps,
    } = this.props;

    // I had to use window.Date to explicitly refer to the global
    // Date, otherwise we instantiate this component class itself,
    // cause its also called Date
    const fallback = new window.Date();
    // parse time into moment format and compare with "now"
    const parsedTime = parseISO(value || fallback.toISOString());
    const diff = differenceInHours(new window.Date(), parsedTime);
    // const language = getCanonicalLanguage(i18n.language);
    // const momentLanguage = language.toLowerCase();
    // To localise statically import and select available locales.
    //
    return (
      // if difference is greater than 72 hours (i.e. 3 days), display full date
      // otherwise, display relative time (e.g. "just now", "16 hours ago", "2 days ago")
      // Add locales to date-fns functions below
      <>
        {!hideTooltip && (
          <Tooltip
            delayShow={500}
            place='top'
            {...(tooltipProps || {})}
            id='relativeTimestamp'
          />
        )}
        <time
          data-testid={dataTestId}
          className={className}
          dateTime={formatISO(parsedTime)}
          data-for='relativeTimestamp'
          data-tip={formatDate(parsedTime, DataFormatter.full)}
        >
          {diff > 72 || noRelative
            ? format(parsedTime, formatter || 'do MMM yyyy')
            : formatDistanceToNow(parsedTime, { addSuffix: true })}
        </time>
      </>
    );
  }
}
export default Date;

Date.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  short: PropTypes.bool,
  noRelative: PropTypes.bool,
  dataTestId: PropTypes.string,
};
